/**
 * Latency formatting utility
 * Converts milliseconds into a human-readable duration string.
 *
 * Rules:
 *  - 0 / null / undefined → "0s"
 *  - < 60 seconds         → "Xs"
 *  - ≥ 60 seconds         → "Xm Ys"
 *  - ≥ 3600 seconds       → "Xh Ym Zs"
 */
export const formatLatency = (
  ms: number | null | undefined
): string => {
  if (ms === null || ms === undefined || ms <= 0) return '0s';

  const totalSeconds = Math.round(ms / 1000);

  if (totalSeconds < 60) {
    return `${totalSeconds}s`;
  }

  if (totalSeconds < 3600) {
    const minutes = Math.floor(totalSeconds / 60);
    const seconds = totalSeconds % 60;
    return `${minutes}m ${seconds}s`;
  }

  const hours = Math.floor(totalSeconds / 3600);
  const minutes = Math.floor((totalSeconds % 3600) / 60);
  const seconds = totalSeconds % 60;
  return `${hours}h ${minutes}m ${seconds}s`;
};
